var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNissan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_755_9219",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_755_9219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4862 17.1569C42.0796 17.0364 41.6269 16.9794 40.6732 16.8545C36.7259 16.6826 26.9711 16.2799 22.0002 16.2799C17.0295 16.2799 7.27452 16.6823 3.32772 16.8545C2.37358 16.9794 1.92038 17.0364 1.51404 17.1569C0.27302 17.4676 0 17.9405 0 18.8841V25.3512C0 26.295 0.95238 26.931 1.60886 27.0592C2.26578 27.1883 2.68136 27.24 3.37238 27.3098C6.90272 27.542 15.0933 28.0259 22 28.0336C28.9069 28.0266 37.0971 27.5422 40.6276 27.3098C41.3184 27.24 41.7342 27.1881 42.3914 27.0592C43.0476 26.9307 44 26.295 44 25.3512V18.8841C44 17.9405 43.7272 17.4676 42.4862 17.1569Z",
    fill: "url(#paint0_linear_755_9219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.17099 17.4112C8.11315 10.2386 14.4947 4.97579 22.07 4.97579C29.6234 4.97579 35.992 10.2096 37.9531 17.3536C37.9592 17.3788 37.9634 17.3919 37.9702 17.4161C39.0962 17.2819 40.1049 17.0745 40.8177 16.8724C40.8047 16.8264 40.8014 16.8171 40.7902 16.7718C38.5614 8.26199 31.0246 2 22.07 2C13.0852 2 5.52859 8.30263 3.32727 16.8544C4.31749 17.1424 5.04283 17.2632 6.17099 17.4112Z",
    fill: "url(#paint1_radial_755_9219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9067 26.8121C37.8871 26.8759 37.8654 26.9462 37.8552 26.981C35.7901 33.9532 29.5047 39.0243 22.0702 39.0243C14.577 39.0243 8.25204 33.875 6.23706 26.8189C5.0055 27.0504 4.58948 27.1384 3.37244 27.3103C5.62744 35.7785 13.1435 42.0001 22.0702 42.0001C31.0007 42.0001 38.5194 35.772 40.7702 27.2968C39.698 27.1562 39.0663 27.0499 37.9067 26.8121Z",
    fill: "url(#paint2_radial_755_9219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56746 17.3958C7.03496 17.1907 7.48728 16.8637 8.19238 16.6533C10.2945 10.8552 15.714 6.72628 22.0698 6.72628C28.4058 6.72628 33.8118 10.8297 35.9271 16.5998C35.9346 16.6194 35.9423 16.6433 35.9482 16.658C36.3121 16.7918 37.3842 17.2533 37.7177 17.4077C37.765 17.4089 37.866 17.4126 37.9703 17.4156C37.9641 17.3949 37.9584 17.374 37.9531 17.353C35.9911 10.2115 29.6228 4.97925 22.0698 4.97925C14.4965 4.97925 8.11494 10.2397 6.17212 17.411C6.28432 17.4112 6.49794 17.4009 6.56746 17.3958Z",
    fill: "url(#paint3_radial_755_9219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9491 5.46437C29.036 5.46437 35.3181 9.9506 37.6976 17.3454L37.717 17.4082C37.7539 17.4082 37.8888 17.4133 37.9695 17.4161C37.9631 17.3893 37.9565 17.3736 37.9524 17.3535C35.9904 10.212 29.6221 4.97974 22.069 4.97974C14.4957 4.97974 8.11421 10.2402 6.17139 17.4115C6.32275 17.4089 6.39557 17.4089 6.56717 17.396C8.69457 10.3757 14.9144 5.46437 21.9491 5.46437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5049 26.8323C36.9958 27.1343 36.362 27.4249 35.8553 27.5947C35.8485 27.612 35.8197 27.6886 35.8135 27.7066C33.6219 33.3171 28.2941 37.2776 22.0699 37.2776C15.8065 37.2776 10.4515 33.269 8.28536 27.6029C7.70258 27.4312 6.83138 27.0094 6.5016 26.8333C6.37818 26.827 6.31174 26.8232 6.23584 26.819C8.25082 33.8742 14.5769 39.0244 22.0701 39.0244C29.5294 39.0244 35.8311 33.9214 37.8756 26.916C37.88 26.9024 37.9026 26.8253 37.9075 26.8123C37.7893 26.8172 37.6087 26.8323 37.5049 26.8323Z",
    fill: "url(#paint4_radial_755_9219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1335 17.6253C41.0881 17.4903 40.3753 17.5048 37.8286 17.4116C37.7128 17.4071 37.5951 17.4034 37.4757 17.399C32.8579 17.2308 25.9213 17.0061 22 17.0061C18.0789 17.0061 11.1426 17.2308 6.5241 17.399C6.40486 17.4034 6.2876 17.4071 6.1721 17.4116C3.62494 17.5048 2.91236 17.4903 1.8667 17.6253C0.82126 17.7614 0 18.2475 0 19.074V25.0712C0 25.8982 0.98934 26.5678 1.86648 26.5678C1.86648 26.5678 13.0306 27.2996 22 27.3082C30.9696 27.2996 42.1335 26.5678 42.1335 26.5678C43.0107 26.5678 44 25.8982 44 25.0712V19.074C44 18.2475 43.179 17.7614 42.1335 17.6253Z",
    fill: "url(#paint5_radial_755_9219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5049 26.8323C35.3139 33.7324 29.1522 38.539 22.192 38.539C15.161 38.539 8.92228 34.1234 6.50096 26.8323C6.41208 26.8274 6.32408 26.8237 6.23718 26.8183C8.25172 33.8737 14.5789 39.0239 22.0723 39.0239C29.5682 39.0239 35.896 33.8704 37.9088 26.8113C37.7764 26.8178 37.642 26.8255 37.5049 26.8323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5178 26.8319L37.5043 26.8324C36.9952 27.1344 36.3619 27.4249 35.8548 27.5947C35.8479 27.612 35.8191 27.6886 35.8132 27.7066C35.1198 29.4821 34.1122 31.0923 32.8604 32.4644C34.8197 30.9437 36.4178 29.0225 37.5178 26.8319Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7018 32.9108C10.2283 31.4207 9.05523 29.6169 8.28523 27.6024C7.70245 27.4305 6.83146 27.0085 6.50146 26.8324C6.85411 27.6085 7.26987 28.3505 7.74403 29.0498C8.71401 30.3909 9.88969 31.5863 11.2279 32.5978C11.3837 32.7062 11.5417 32.8104 11.7018 32.9108Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23659 26.8193V26.8188L6.23153 26.8198C5.00393 27.0508 4.58747 27.1393 3.37219 27.3103C3.47009 27.6793 3.57855 28.0429 3.69669 28.4029L6.23659 26.8193Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9401 20.2813C30.5732 19.4106 30.7034 19.502 29.9046 19.4795C29.8397 19.4562 29.6665 19.4562 29.4294 19.4562C29.1927 19.4562 29.1491 19.4562 28.9546 19.4795C28.1996 19.4795 28.3289 19.4338 28.0702 20.0064C28.0702 20.0064 26.7742 23.0993 26.2136 24.3822L26.1921 24.428C26.0843 24.6566 26.1492 24.6566 26.3214 24.6566H27.4872C27.5739 24.6566 27.6166 24.6118 27.6381 24.5651C27.6381 24.5651 27.8108 24.1755 28.0267 23.6259H30.8754C31.0915 24.1531 31.2424 24.5422 31.2424 24.5651C31.264 24.634 31.3289 24.6566 31.3933 24.6566H32.602C32.7747 24.6566 32.818 24.6807 32.7534 24.5193C32.5371 23.9697 31.1344 20.7618 30.9401 20.2813ZM28.4579 22.5263C28.8248 21.6101 29.1922 20.7167 29.1922 20.6936C29.214 20.6476 29.2571 20.6247 29.3216 20.6247C29.3434 20.6013 29.4085 20.6013 29.4729 20.6013C29.5163 20.6013 29.5805 20.6013 29.6023 20.6247C29.6452 20.6247 29.6892 20.6476 29.7099 20.7165C29.797 20.968 30.12 21.7474 30.422 22.5263H28.4579ZM12.9188 19.4104C13.0266 19.4104 13.0484 19.4559 13.0484 19.5477V24.4513C13.0484 24.5653 13.0266 24.612 12.8975 24.612H11.775C11.6459 24.612 11.6243 24.5887 11.6243 24.4513V19.5477C11.6243 19.4559 11.6459 19.4104 11.7319 19.4104H12.9188ZM10.5232 19.4559C10.6524 19.4559 10.6746 19.5015 10.6746 19.6166V24.4971C10.6746 24.6349 10.6524 24.6578 10.5232 24.6578H9.20654C8.42994 24.6578 8.36504 24.6578 8.10632 24.2C7.56666 23.3067 5.94768 20.6716 5.94768 20.6716V24.4976C5.94768 24.6356 5.92612 24.658 5.79698 24.658H4.82546C4.6961 24.658 4.67432 24.6356 4.67432 24.4976V19.6166C4.67432 19.502 4.6961 19.4559 4.82546 19.4559H5.94768C6.7894 19.4559 6.8972 19.4333 7.19992 19.8915C7.43708 20.3042 9.40102 23.5117 9.40102 23.5117V19.6166C9.40102 19.502 9.42258 19.4559 9.55238 19.4559H10.5232ZM39.3353 19.4559C39.4656 19.4559 39.4867 19.5015 39.4867 19.6166V24.4971C39.4867 24.6349 39.4651 24.6578 39.3353 24.6578H38.0199C37.2422 24.6578 37.1773 24.6578 36.9186 24.2C36.3785 23.306 34.76 20.6712 34.76 20.6712V24.4973C34.76 24.6351 34.7384 24.6576 34.6086 24.6576H33.638C33.5086 24.6576 33.4864 24.6351 33.4864 24.4973V19.6166C33.4864 19.502 33.5088 19.4559 33.638 19.4559H34.76C35.6017 19.4559 35.7099 19.4333 36.0116 19.8915C36.2707 20.3042 38.2133 23.5117 38.2133 23.5117V19.6166C38.2133 19.502 38.2351 19.4559 38.3647 19.4559H39.3353ZM17.8613 21.4501C18.7248 21.5414 19.351 21.7016 19.5234 22.5726C19.5234 22.6408 19.5452 22.8701 19.5452 23.1224C19.5452 23.2831 19.5452 23.4886 19.5019 23.6722C19.3512 24.4969 18.768 24.6571 17.862 24.6571H14.2355C14.1059 24.6571 14.0842 24.6347 14.0842 24.4969V23.6722C14.0842 23.5344 14.1059 23.5115 14.2355 23.5115H17.904C18.0554 23.5115 18.0985 23.4659 18.1198 23.3508V23.1446V23.0072C18.0981 22.9152 18.0767 22.7779 17.8827 22.7555C17.4724 22.7326 16.2641 22.6176 15.4435 22.5263C14.386 22.4116 14.1273 21.931 14.0839 21.5183C14.0624 21.3805 14.0624 21.1974 14.0624 21.0369C14.0624 20.8993 14.0624 20.6933 14.0839 20.5327C14.2353 19.799 14.7534 19.4559 15.6594 19.4559H19.1772C19.3072 19.4559 19.3505 19.4793 19.3505 19.5935V20.4416C19.3505 20.5553 19.3072 20.6016 19.1772 20.5787H15.7243C15.5731 20.5787 15.5087 20.6473 15.4867 20.8076V21.0138C15.4867 21.1285 15.5516 21.2203 15.7025 21.2424C16.1134 21.2892 17.3864 21.4036 17.8613 21.4501ZM24.0981 21.4501C24.9623 21.5414 25.5877 21.7016 25.7607 22.5726C25.7607 22.6408 25.7822 22.8701 25.7822 23.1224C25.7822 23.2831 25.7822 23.4886 25.7391 23.6722C25.5884 24.4969 25.0058 24.6571 24.099 24.6571H20.4727C20.3432 24.6571 20.3214 24.6347 20.3214 24.4969V23.6722C20.3214 23.5344 20.3432 23.5115 20.4727 23.5115H24.1419C24.2928 23.5115 24.3353 23.4659 24.3575 23.3508V23.1446V23.0072C24.3351 22.9152 24.2924 22.7779 24.1199 22.7555C23.71 22.7326 22.5014 22.6176 21.6814 22.5263C20.6234 22.4116 20.3865 21.931 20.3214 21.5183C20.2998 21.3805 20.2998 21.1974 20.2998 21.0369C20.2998 20.8993 20.2998 20.6933 20.3214 20.5327C20.4727 19.799 20.9906 19.4559 21.8968 19.4559H25.4153C25.5442 19.4559 25.588 19.4793 25.588 19.5935V20.4416C25.588 20.5553 25.5442 20.6016 25.4153 20.5787H21.9617C21.8108 20.5787 21.7463 20.6473 21.7243 20.8076V21.0138C21.7243 21.1285 21.7677 21.2203 21.9406 21.2424C22.3507 21.2892 23.6236 21.4036 24.0981 21.4501Z",
    fill: "url(#paint6_radial_755_9219)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_755_9219",
    x1: 22,
    y1: 2.59047,
    x2: 22,
    y2: 35.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_755_9219",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.64853 -6.04125) scale(30.6819 32.573)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_755_9219",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.9006 46.1325) scale(63.899 67.8376)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_755_9219",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.0181 31.1623) scale(19.6172 20.8263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_755_9219",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.8486 52.4579) scale(37.2227 39.517)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_755_9219",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7052 6.12079) scale(29.5794 31.4026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_755_9219",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.3903 9.26548) scale(19.9234 21.1515)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNissan);
export default __webpack_public_path__ + "static/media/nissan.216ebcb79989c0964225eb2e2c484b50.svg";
export { ForwardRef as ReactComponent };